// extracted by mini-css-extract-plugin
export default {"container":"explainer_container__COfMP","description":"explainer_description__B2bhR","link":"explainer_link__zT2oR"};